<template>
<tr>
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">
        <template v-if="room.name">{{room.name}}</template>
        <template v-else>{{$t('room_type_slug.' +room.slug)}}</template>
    </th>
    <td class="sheet-cell text-center" v-for="(day, index) in prices" :key="index">
        <v-progress-circular v-if="loading_date == day.date" size="12" width="2" indeterminate />
        <input v-else v-model.lazy="day.price" class="sheet-input" @change="save(day)" type="number" />
    </td>
</tr>
</template>

<script>
import {
    mapActions
} from 'vuex';
export default {
    props: {
        room: Object,
        prices: Object,
    },

    data() {
        return {
            loading_date: null,
        }
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        save(day) {
            let room = {
                [this.room.id]: {
                    [day.date]: day
                }
            }

            this.loading_date = day.date;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/components';

            // setup query params
            let params = {
                hotel_id: day.hotel_id,
                date_start: day.date,
                date_stop: day.date,
                sheet: {
                    room_types: room
                }
            };

            this.$axios.post(endpoint, params)
                .then(response => {
                    this.success(this.$t('sheet.message_update'));
                })
                .catch(error => {
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.loading_date = null;
                });

        }

    },
}
</script>
